import { createAction, props } from '@ngrx/store';
import { Slider } from '../../models';

export const LoadSlider = createAction('[Content Slider] Load Content Slider', props<{ id: number }>());
export const LoadSliderSuccess = createAction('[Content Slider] Load Content Slider Success', props<{ slider: Slider }>());
export const LoadSliderFail = createAction('[Content Slider] Load Content Slider Fail', props<{ error: any }>());
